import { useLocale } from './useLocale';

/**
 * Date/Time Formatter
 * @example
 * const date = 1633696971688;
 * const dateTimeFormatter = useDateTimeFormatter();
 * Results: dateTimeFormatter.format(1633696971688) ==> 10/8/2021
 *
 * const date = 1633696971688;
 * const options = {
 *      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
 * } as Intl.DateTimeFormatOptions
 * const dateTimeFormatter = useDateTimeFormatter(options);
 * Results: dateTimeFormatter.format(1633696971688) ==> Friday, October 8, 2021
 *
 * const date = 1633696971688;
 * const options = {
 *      year: 'numeric', month: 'numeric', day: 'numeric',
 *      hour: 'numeric', minute: 'numeric', second: 'numeric',
 *      hour12: false,
 * } as Intl.DateTimeFormatOptions;
 * const dateTimeFormatter = useDateTimeFormatter(options);
 * Results: dateTimeFormatter.format(1633696971688) ==> 10/8/2021, 07:42:51
 *
 * For more options, see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
 */
export function useDateTimeFormatter(options: Intl.DateTimeFormatOptions = {}) {
  const { locale } = useLocale();
  return new Intl.DateTimeFormat(locale, options);
}
